var map = {
	"./canned-food.png": "2bd0",
	"./childrens-products.png": "6b1b",
	"./confectionery.png": "d67a",
	"./dairy.png": "631e",
	"./frozen-food.png": "2677",
	"./fruits.png": "24ee",
	"./gastronomy.png": "617c",
	"./grocery.png": "3f51",
	"./household-chemicals.png": "7c8b",
	"./household-goods.png": "8410",
	"./hygiene-products.png": "b761",
	"./meat.png": "5c20",
	"./other-products.png": "bb5d",
	"./own-production.png": "c057",
	"./soft-drinks.png": "8988",
	"./tea.png": "5046",
	"./textile.png": "becb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c325";